(function () {
  function setupAccordions(root) {
    var containers = (root || document).querySelectorAll('.accordion-container:not([data-ii-accordion-ready])');

    containers.forEach(function (container) {
      container.setAttribute('data-ii-accordion-ready', 'true');

      var items = container.querySelectorAll('.accordion-item');

      items.forEach(function (item, index) {
        var title = item.querySelector('.accordion-title');
        var content = item.querySelector('.accordion-content');

        if (!title || !content) return;

        var isOpen = item.classList.contains('active') || item.classList.contains('open');

        title.setAttribute('role', 'button');
        title.setAttribute('tabindex', '0');
        title.setAttribute('aria-expanded', isOpen ? 'true' : 'false');

        if (!content.id) {
          content.id = 'ii-accordion-content-' + Date.now() + '-' + index;
        }

        title.setAttribute('aria-controls', content.id);

        if (!isOpen) {
          content.hidden = true;
        }
      });
    });
  }

  function toggleAccordion(title) {
    var item = title.closest('.accordion-item');
    if (!item) return;

    var content = item.querySelector('.accordion-content');
    if (!content) return;

    var isOpen = item.classList.contains('active') || item.classList.contains('open');

    item.classList.toggle('active', !isOpen);
    item.classList.toggle('open', !isOpen);

    content.hidden = isOpen;
    title.setAttribute('aria-expanded', !isOpen ? 'true' : 'false');
  }

  document.addEventListener('click', function (event) {
    var title = event.target.closest('.accordion-container .accordion-title');
    if (!title) return;

    event.preventDefault();
    toggleAccordion(title);
  });

  document.addEventListener('keydown', function (event) {
    var title = event.target.closest('.accordion-container .accordion-title');
    if (!title) return;

    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      toggleAccordion(title);
    }
  });

  document.addEventListener('DOMContentLoaded', function () {
    setupAccordions(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    setupAccordions(event.target);
  });
})();